import { defineReceiver } from '@drapejs/invoker';
import { fetchPage } from '@drapejs/core';
import { batch } from '@distancify/drapejs-litium';
import { gql } from 'graphql-request';

import {
  getProductBlockCacheKey,
  hasProductDataSource,
} from '../composables/useProductBlock';
import { processBlocks } from '@/helpers/commandsHelper';

import { getProductsSearchFields } from './category';

export const schedule = defineReceiver(
  fetchPage,
  async function (_command, data) {
    await processBlocks(data, 'ProductGrid', async (block) => {
      if (!hasProductDataSource(block)) return;

      await this.invoke(batch.scheduleQuery, {
        cacheKey: getProductBlockCacheKey(block),
        query: gql`
        elasticSearch{
          productGridBlockProducts(blockId: $blockId){
            ${getProductsSearchFields()}
          }
        }`,
        variables: {
          blockId: {
            value: block.systemId,
            type: 'Guid!',
          },
        },
      });
    });

    return data;
  }
);
